module.exports = __webpack_public_path__ + "img/p4.d07e54dc.png";